module.exports = __webpack_public_path__ + "img/caro-5.42715a1c.jpg";